/** Browsers (zeker op Windows) geven soms lege of generieke MIME-types; extensie als fallback. */
const EXT_IMAGE_OR_PDF = /\.(png|jpe?g|webp|gif|pdf)$/i;

export function isAcceptedImageOrPdfFile(file: File): boolean {
  if (file.type.startsWith('image/') || file.type === 'application/pdf') return true;
  if (file.type === 'application/octet-stream' && EXT_IMAGE_OR_PDF.test(file.name)) return true;
  if (!file.type && EXT_IMAGE_OR_PDF.test(file.name)) return true;
  return false;
}

export function libraryContentTypeForFile(file: File): string {
  if (file.type && file.type !== 'application/octet-stream') return file.type;
  const n = file.name.toLowerCase();
  if (n.endsWith('.pdf')) return 'application/pdf';
  if (n.endsWith('.png')) return 'image/png';
  if (n.endsWith('.jpg') || n.endsWith('.jpeg')) return 'image/jpeg';
  if (n.endsWith('.webp')) return 'image/webp';
  if (n.endsWith('.gif')) return 'image/gif';
  return file.type || 'application/octet-stream';
}
